import { render, staticRenderFns } from "./NewStudentPage.vue?vue&type=template&id=9eb60e1a&scoped=true&"
import script from "./NewStudentPage.vue?vue&type=script&lang=ts&"
export * from "./NewStudentPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewStudentPage.vue?vue&type=style&index=0&id=9eb60e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb60e1a",
  null
  
)

export default component.exports